let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("NFlEP")).then(() => parcelRequire('ackSe'));